import { Component } from '@angular/core';
import { SERVICE_SETTINGS_CARE_PLAN_TYPE_KEY } from '@libs/types/src/services/types/common-service-settings.type';
import {
    ServiceSettingsCommonComponent,
} from '../../../../components/services/settings/service-settings-common/service-settings-common.component';

@Component({
    selector: 'app-service-settings-care-plan',
    templateUrl: './service-settings-care-plan.component.html',
    styleUrl: './service-settings-care-plan.component.scss',
    imports: [
        ServiceSettingsCommonComponent,
    ],
})
export class ServiceSettingsCarePlanComponent {
    protected readonly SERVICE_SETTINGS_CARE_PLAN_TYPE_KEY = SERVICE_SETTINGS_CARE_PLAN_TYPE_KEY;
}
